import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__Slot_js_7a50c2c6__ from "../Slot.js";
import * as __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__ from "./Button.module.js";
const buttonClass = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)(__WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].button, {
    variants: {
        appearance: {
            primary: __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].primary,
            secondary: __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].secondary,
            ternary: __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].ternary,
            link: __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].link
        },
        size: {
            sm: __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].small,
            lg: __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].large
        },
        shadow: {
            true: __WEBPACK_EXTERNAL_MODULE__Button_module_js_2e345e34__["default"].shadow
        }
    },
    defaultVariants: {
        appearance: 'primary',
        size: 'sm',
        shadow: true
    }
});
function Button(props) {
    const { asChild, children, className, appearance, shadow, size, ...other } = props;
    const Comp = asChild ? __WEBPACK_EXTERNAL_MODULE__Slot_js_7a50c2c6__["default"] : 'button';
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        ...asChild ? {} : {
            type: props.type ?? 'button'
        },
        className: buttonClass({
            appearance,
            size,
            shadow,
            className
        }),
        ...other,
        children: children
    });
}
export { Button as default };

//# sourceMappingURL=Button.js.map